// extracted by mini-css-extract-plugin
export default {"overlay":"hw-z","bodyOpen":"iw-z","content":"jw-z","header":"kw-z","close":"lw-z","closeNoHeading":"mw-z"};